<template>
  <!-- <main class="event-detail detail" role="main">
    <header-details :details="event" :type="'event'" />
    <section-nav
      :sections="sectionsNav"
      :have-description="true"
      :have-gallery="true"
      class="d-none d-md-block"
    />
    <b-container class="detail-container">
      <sign-banner v-if="!$store.state.auth.userIsAuthenticated && !buyer" />
      <information
        v-if="
          event.description ||
            event.links ||
            event.spotify_id ||
            event.start_date ||
            event.companies ||
            event.tags
        "
        id="info"
        :description="event.description"
        :links="event.links"
        :spotify="event.spotify_id"
        :date="event.start_date"
        :companies="event.companies"
        :tags="event.tags"
      />
      <localization
        v-if="event.venue"
        id="localization"
        :accommodation="event.accommodation"
        :venue="event.venue"
        :transport="event.transport"
      />
      <aside>
        <gallery
          v-if="gallery && gallery.length > 0"
          id="gallery"
          :gallery="gallery"
        />
      </aside>
      <fb-pixel
        v-if="event.facebook_pixel_js"
        :fb-pixel="event.facebook_pixel_js"
      />
      <ga-pixel
        v-if="event.google_pixel_js"
        :ga-pixel="event.google_pixel_js"
      />
    </b-container>
    <purchase-needed
      event-to-emit="closeSignupPurchaseNoCreate"
      event-to-emit-basic="closeBasicInfoPurchaseNoCreate"
    />
    <dynamic-ads
      v-if="event.ads"
      :values="
          !!event.ads['desktop_event_dynamic']
          ? event.ads['desktop_event_dynamic'].values
          : event.ads['responsive_event_dynamic'].values
        " />
    <smart-clip :slot-name="'wegow-web-dynamic-ad'"
                :type="'sc-dynamic-ad'"
                :page="'landing'"
                :values="{}"
                :description="'sc-dynamic-ad'" />
  </main> -->

    <div class="bee-page-container">
      <div class="bee-row bee-row-1">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-image">
              <a href="http://www.example.com/">
              <img alt="Store Logo" class="bee-center bee-fixedwidth" src="images/Recurso_33x.png" style="max-width:257px;"/></a>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-2">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-divider">
              <div class="center" style="border-top:0px solid #BBBBBB;width:100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-3">
        <div class="bee-row-content reverse">
          <div class="bee-col bee-col-1 bee-col-w6">
            <div class="bee-block bee-block-1 bee-image">
              <img alt="Labor day sale" class="bee-center bee-fixedwidth" src="images/LP_imagen-04-04-04.png" style="max-width:586px;"/>
            </div>
          </div>
          <div class="bee-col bee-col-2 bee-col-w6">
            <div class="bee-block bee-block-1 bee-heading">
              <h1 style="color:#ffffff;direction:ltr;font-family:Verdana, Geneva, sans-serif;font-size:42px;font-weight:700;letter-spacing:2px;line-height:120%;text-align:center;margin-top:0;margin-bottom:0;">
                <span class="tinyMce-placeholder">
                ¡VEN CON TUS AMIGXS AL 15 ANIVERSARIO DE DESALIA!
                </span>
              </h1>
            </div>
            <div class="bee-block bee-block-2 bee-text">
              <div class="bee-text-content" style="font-size: 14px; line-height: 150%; font-family: Verdana, Geneva, sans-serif; color: #ffecdb;">
                <p style="text-align: center; line-height: 21px; letter-spacing: normal;">
                  <span style="font-size: 22px; line-height: 39px;">
                  Demuestra cómo de viveahorista eres y vente a República Dominicana con otras 1000 personas entre el 28 de mayo y 5 de junio.
                  </span>
                </p>
                <p aria-label="Atajos de mensaje" role="group" style="line-height: 21px; letter-spacing: normal;">

                </p>
              </div>
            </div>
            <div class="bee-block bee-block-3 bee-text">
              <div class="bee-text-content" style="font-size: 14px; line-height: 150%; font-family: Verdana, Geneva, sans-serif; color: #941313;">
                <p style="text-align: center; line-height: 33px; font-size: 22px; letter-spacing: normal;">
                  <span style="font-size: 22px; line-height: 33px;">
                  <strong style="">
                  ¿Qué tres hits no pueden faltar en Desalia
                  </strong>
                  </span>
                </p>
                <p style="text-align: center; line-height: 33px; font-size: 22px; letter-spacing: normal;">
                  <span style="font-size: 22px; line-height: 33px;">
                  <strong style="">
                  para un auténtico viveahorista?
                  </strong>
                  </span>
                </p>
              </div>
            </div>
            <div class="bee-block bee-block-4 bee-form">
              <form accept-charset="UTF-8" action="ACTION_PLACEHOLDER" autocomplete="on" enctype="multipart/form-data" method="post" target="_self">
                <div class="bee-form-row">
                  <div class="bee-field bee-field-id_4fq8ip">
                    <label for="id_4fq8ip">
                    Tres Hits
                    </label>
                    <textarea id="id_4fq8ip" name="message"></textarea>
                  </div>
                </div>
                <div class="bee-form-row">
                  <div class="bee-field bee-field-id_lt5tic">
                    <label for="id_lt5tic">
                    Nombre y Apellidos
                    </label>
                    <input id="id_lt5tic" name="firstname" required="" type="text"/>
                  </div>
                </div>
                <div class="bee-form-row">
                  <div class="bee-field bee-field-id_e2n8r4">
                    <label for="id_e2n8r4">
                    Fecha de nacimiento
                    </label>
                    <input id="id_e2n8r4" name="birthday" type="date"/>
                  </div>
                </div>
                <div class="bee-form-row">
                  <div class="bee-field bee-field-id_1ky111">
                    <label for="id_1ky111">
                    Email
                    </label>
                    <input id="id_1ky111" name="email" required="" type="text"/>
                  </div>
                </div>
                <div class="bee-form-row">
                  <div class="bee-field bee-field-id_yoodug bee-inline-field">
                    <input id="id_yoodug" name="privacy_policy" type="checkbox"/>
                    <label class="inline" for="id_yoodug">
                    Acepto los términos y Condiciones del concurso
                    </label>
                  </div>
                </div>
                <div class="bee-form-row">
                  <div class="bee-field bee-field-id_1w3fbo">
                    <div class="bee-button-container">
                      <button id="id_1w3fbo" name="submit" type="submit" value="SIGN IN">
                      SIGN IN
                      </button>
                    </div>
                  </div>
                </div>
                <div class="bee-form-row"></div>
                <div class="bee-form-row"></div>
                <div class="bee-form-row"></div>
                <div class="bee-form-row"></div>
                <div class="bee-form-row"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-4">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w6">
            <div class="bee-block bee-block-1 bee-image">
              <img alt="" class="bee-fixedwidth" src="images/Recurso_12x.png" style="max-width:133px;"/>
            </div>
          </div>
          <div class="bee-col bee-col-2 bee-col-w6">
            <div class="bee-block bee-block-1 bee-social">
              <div class="content">
                <span class="icon" style="padding:0 5px 0 5px;">
                <a href="https://www.facebook.com/ron.bercelo">
                <img alt="Facebook" src="images/facebook2x.png" title="facebook"/></a>
                </span>
                <span class="icon" style="padding:0 5px 0 5px;">
                <a href="https://www.instagram.com/ronbarcelospain/">
                <img alt="Instagram" src="images/instagram2x.png" title="instagram"/></a>
                </span>
                <span class="icon" style="padding:0 5px 0 5px;">
                <a href="https://twitter.com/RonBarceloSpain">
                <img alt="Twitter" src="images/twitter2x.png" title="Twitter"/></a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bee-row bee-row-5">
        <div class="bee-row-content">
          <div class="bee-col bee-col-1 bee-col-w12">
            <div class="bee-block bee-block-1 bee-divider">
              <div class="spacer" style="height:15px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mixpanelEvents } from '@/plugins/mixins/mixpanel/events/events'
import HeaderDetails from '@/components/header-details/HeaderDetails.vue'
import PurchaseNeeded from '@/components/purchase-needed/PurchaseNeeded.vue'
import SectionNav from '@/components/section-nav/SectionNav.vue'
import SignBanner from '@/components/sign-banner/SignBanner.vue'
import Information from '@/components/information/Information.vue'
import Localization from '@/components/localization/Localization.vue'
import FbPixel from '@/components/pixels/FbPixel.vue'
import GaPixel from '@/components/pixels/GaPixel.vue'
import Gallery from '@/components/gallery/Gallery.vue'
import DynamicAds from '@/components/wegow-ads/dynamic-ads'
import SmartClip from '@/components/wegow-ads/SmartClip.vue'

export default {
  components: {
    DynamicAds,
    HeaderDetails,
    SectionNav,
    SignBanner,
    Information,
    Localization,
    FbPixel,
    GaPixel,
    PurchaseNeeded,
    Gallery,
    SmartClip
  },
  mixins: [mixpanelEvents],
  data: () => ({
    sectionsNav: [
      {
        title: 'Información',
        id: 'info',
        text: 'events.informacion'
      },
      {
        title: 'Localización',
        id: 'localization',
        text: 'events.localizacion'
      }
    ],
    sign: process.env.VUE_APP_SIGN,
    buyer: process.env.VUE_APP_BUYER === 'true'
  }),
  computed: {
    event() {
      return this.$store.state.event.detail
    },
    gallery() {
      return this.$store.state.gallery.list
    }
  },
  async mounted() {
    await this.$store.dispatch('gallery/getProgram')
    await this.$store.dispatch('gallery/getGallery')
    this.$ga.page({
      page: window.location.pathname,
      title: this.$store.state.event.detail.title,
      location: window.location.href
    })
    this.gtmViewEvent(this.$store.state.event.detail)
    if (this.$store.state.auth.userIsAuthenticated) {
      if (typeof window.fbq !== 'undefined') {
        window.fbq('track', 'ViewContent', {
          content_ids: [this.$store.state.event.detail.id],
          content_name: this.$store.state.event.detail.title
        })
      }
    }
  }
}
</script>
